document.addEventListener('DOMContentLoaded', function () {

    // 1. Helpers & State
    const formatMoney = (cents) => {
        return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const normalize = (str) => str ? str.toString().toLowerCase().trim() : '';

    const variantData = window.productVariants || [];
    const productOptions = window.productOptions || []; // e.g. ["Color", "Size"] OR ["Pattern", "Capacity"]

    const priceContainer = document.querySelector('.ict-add-btn span:last-child');
    const addBtnText = document.querySelector('.ict-add-btn span:first-child');
    const addBtn = document.querySelector('.ict-add-btn');

    // State is now generic: holds value for each option index
    // e.g. [ "Red", "L" ]
    let state = {
        options: new Array(productOptions.length).fill(null)
    };

    // Determine which index is the "Visual" one (for image filtering)
    // We look for Color, Pattern, Style, etc.
    let visualOptionIndex = -1;
    productOptions.forEach((name, idx) => {
        const n = normalize(name);
        if (n.includes('color') || n.includes('colour') || n.includes('pattern') || n.includes('style') || n.includes('design') || n.includes('material')) {
            if (visualOptionIndex === -1) visualOptionIndex = idx; // Pick first match
        }
    });
    // Fallback: If no specific visual name found, default to first option if it exists
    // Fallback REMOVED: Do not default to first option (e.g. Size) if no visual option matches.
    // This prevents images from being hidden when multiple variants (sizes) share the same image.
    /*
    if (visualOptionIndex === -1 && productOptions.length > 0) {
        visualOptionIndex = 0;
    }
    */

    console.log("Visual Option Index detected:", visualOptionIndex, productOptions[visualOptionIndex]);


    // 2. Core Logic

    // --- Variant Matching ---
    const updateVariant = () => {
        // Get which options actually have UI elements (need to be selected)
        const optionsWithUI = [];
        productOptions.forEach((_, idx) => {
            // Look for div wrappers (not inputs) with data-option-index
            const wrapper = document.querySelector(`div[data-option-index="${idx}"]`);
            // Also check for hidden inputs (for default title options)
            const hiddenInput = document.querySelector(`input[data-option-index="${idx}"]`);
            
            if (wrapper) {
                // Only count as UI if wrapper actually has interactive inputs (not just an empty wrapper)
                const hasInputs = wrapper.querySelector('input[type="radio"]:not([disabled]), select:not([disabled]), input[type="checkbox"]:not([disabled])');
                if (hasInputs) {
                    optionsWithUI.push(idx);
                } else if (hiddenInput) {
                    // Wrapper exists but empty - treat as hidden option
                    // Set state from hidden input value
                    if (hiddenInput.value && !state.options[idx]) {
                        state.options[idx] = hiddenInput.value;
                    }
                }
            } else if (hiddenInput) {
                // Hidden option - still need to track it but don't require user selection
                // Set state from hidden input value
                if (hiddenInput.value && !state.options[idx]) {
                    state.options[idx] = hiddenInput.value;
                }
            }
        });

        console.log("updateVariant called - State:", state.options, "Options with UI:", optionsWithUI);

        // If no options have UI (single variant product or only hidden options), just match the first variant
        if (optionsWithUI.length === 0 && variantData.length > 0) {
            console.log("No visible options - treating as single variant product");
            const firstVariant = variantData[0];
            if (priceContainer) priceContainer.innerText = formatMoney(firstVariant.price);
            if (firstVariant.available) {
                if (addBtnText) addBtnText.innerText = 'Add to cart';
                if (addBtn) {
                    addBtn.disabled = false;
                    addBtn.removeAttribute('data-action');
                }
            } else {
                if (addBtnText) addBtnText.innerText = 'Sold Out';
                if (addBtn) {
                    addBtn.disabled = true;
                    addBtn.removeAttribute('data-action');
                }
            }
            const idInput = document.querySelector('input[name="id"]');
            if (idInput) idInput.value = firstVariant.id;
            console.log("✅ Single variant product - Button updated to:", addBtnText ? addBtnText.innerText : 'N/A');
            return;
        }

        // For products with only one option type (e.g., color only), handle specially
        if (optionsWithUI.length === 1) {
            const singleOptionIdx = optionsWithUI[0];
            const selectedValue = state.options[singleOptionIdx];
            
            console.log("🔍 Single option product - Index:", singleOptionIdx, "Selected:", selectedValue);
            
            if (selectedValue) {
                // Find any variant that matches this single option
                const matchedVariant = variantData.find(v => {
                    if (!v.options || v.options.length <= singleOptionIdx) {
                        console.log("  ⚠ Variant missing options:", v.id, v.options);
                        return false;
                    }
                    const variantValue = v.options[singleOptionIdx];
                    if (!variantValue) {
                        console.log("  ⚠ Variant has no value at index:", v.id, v.options);
                        return false;
                    }
                    const normalizedVariant = normalize(variantValue);
                    const normalizedSelected = normalize(selectedValue);
                    const matches = normalizedVariant === normalizedSelected;
                    if (matches) {
                        console.log("  ✓ Match found! Variant:", v.id, "Value:", variantValue);
                    }
                    return matches;
                });
                
                if (matchedVariant) {
                    console.log("✅ Using matched variant:", matchedVariant.id);
                    if (priceContainer) priceContainer.innerText = formatMoney(matchedVariant.price);
                    if (matchedVariant.available) {
                        if (addBtnText) {
                            addBtnText.innerText = 'Add to cart';
                            console.log("✅ Button text updated to: Add to cart");
                        }
                        if (addBtn) {
                            addBtn.disabled = false;
                            addBtn.removeAttribute('data-action');
                        }
                    } else {
                        if (addBtnText) addBtnText.innerText = 'Sold Out';
                        if (addBtn) {
                            addBtn.disabled = true;
                            addBtn.removeAttribute('data-action');
                        }
                    }
                    const idInput = document.querySelector('input[name="id"]');
                    if (idInput) idInput.value = matchedVariant.id;
                    
                    // URL Update (with error handling)
                    try {
                        const newUrl = new URL(window.location);
                        newUrl.searchParams.set('variant', matchedVariant.id);
                        window.history.replaceState({}, '', newUrl);
                    } catch (e) {
                        console.warn("Could not update URL:", e);
                    }
                    return;
                } else {
                    console.log("❌ No variant match. Selected:", selectedValue);
                    console.log("   Available variants:", variantData.map(v => ({id: v.id, options: v.options})));
                }
            } else {
                console.log("❌ Single option product but no value in state");
            }
        }

        // For products with multiple options, match all selected options
        const matchedVariant = variantData.find(v => {
            // Only check options that have UI elements
            return optionsWithUI.every(idx => {
                const selected = state.options[idx];
                const variantValue = v.options && v.options[idx] ? v.options[idx] : null;
                
                // If no selection for this UI option, can't match
                if (!selected) return false;
                
                // If variant doesn't have a value for this option, can't match
                if (!variantValue) return false;
                
                // If we have a selection, it must match the variant's option value
                return normalize(variantValue) === normalize(selected);
            });
        });

        if (matchedVariant) {
            // Update Price
            if (priceContainer) priceContainer.innerText = formatMoney(matchedVariant.price);

            // Update Button
            if (matchedVariant.available) {
                addBtnText.innerText = 'Add to cart';
                addBtn.disabled = false;
                addBtn.removeAttribute('data-action'); // Remove special handling
            } else {
                addBtnText.innerText = 'Sold Out';
                addBtn.disabled = true;
                addBtn.removeAttribute('data-action');
            }

            // Update ID
            const idInput = document.querySelector('input[name="id"]');
            if (idInput) idInput.value = matchedVariant.id;

            // URL Update (with error handling)
            try {
                const newUrl = new URL(window.location);
                newUrl.searchParams.set('variant', matchedVariant.id);
                window.history.replaceState({}, '', newUrl);
            } catch (e) {
                console.warn("Could not update URL:", e);
            }

        } else {
            // Check if all options WITH UI are selected
            const allRequiredSelected = optionsWithUI.every(idx => state.options[idx] !== null);
            if (allRequiredSelected) {
                // All options selected but no variant found - might be unavailable combination
                console.log("All selected but no variant found");
                addBtnText.innerText = 'Unavailable';
                addBtn.disabled = true;
                addBtn.removeAttribute('data-action');
            } else {
                // Not all required options selected yet
                // Check if we have at least one option selected
                const hasAnySelection = optionsWithUI.some(idx => state.options[idx] !== null);
                
                if (hasAnySelection && optionsWithUI.length === 1) {
                    // Special case: Product with only one option type (e.g., color only, no size)
                    // If that option is selected, try to find any variant with that option
                    const selectedIdx = optionsWithUI.find(idx => state.options[idx] !== null);
                    if (selectedIdx !== undefined) {
                        const selectedValue = state.options[selectedIdx];
                        const fallbackVariant = variantData.find(v => {
                            return normalize(v.options[selectedIdx]) === normalize(selectedValue);
                        });
                        
                        if (fallbackVariant) {
                            // Found a variant - update UI
                            if (priceContainer) priceContainer.innerText = formatMoney(fallbackVariant.price);
                            if (fallbackVariant.available) {
                                addBtnText.innerText = 'Add to cart';
                                addBtn.disabled = false;
                                addBtn.removeAttribute('data-action');
                            } else {
                                addBtnText.innerText = 'Sold Out';
                                addBtn.disabled = true;
                                addBtn.removeAttribute('data-action');
                            }
                            const idInput = document.querySelector('input[name="id"]');
                            if (idInput) idInput.value = fallbackVariant.id;
                            
                            // URL Update
                            const newUrl = new URL(window.location);
                            newUrl.searchParams.set('variant', fallbackVariant.id);
                            window.history.replaceState({}, '', newUrl);
                            return; // Exit early
                        }
                    }
                }
                
                // Default: Show "Select Options"
                addBtnText.innerText = 'Select Options';
                addBtn.disabled = false; // Enable button so it can be clicked
                addBtn.setAttribute('data-action', 'select-options'); // Mark for special handling
            }
        }
    };

    // --- Visual Filter & Dynamic Layout ---
    const filterAndLayout = () => {
        if (visualOptionIndex === -1) return; // No visual filtering possible

        const selectedVisualValue = normalize(state.options[visualOptionIndex]);
        if (!selectedVisualValue) return;

        // 1. Build Media Map (MediaID -> OptionValue)
        // This tells us "Image 123 belongs to Blue"
        const mediaMap = {};
        variantData.forEach(v => {
            const visualVal = normalize(v.options[visualOptionIndex]);
            if (v.featured_media && v.featured_media.id) {
                mediaMap[v.featured_media.id] = visualVal;
            }
        });

        // 2. Identify Possible Values for Fallback (Alt Text)
        // Also setup Synonyms logic
        const possibleVisualValues = [...new Set(variantData.map(v => normalize(v.options[visualOptionIndex])))];
        possibleVisualValues.sort((a, b) => b.length - a.length);

        // SYNONM MAP: Help map Alt Text colors (e.g. "Blue") to Variant Options (e.g. "Navy")
        const synonymMap = {
            'navy': ['blue', 'indigo', 'dark blue'],
            'burgundy': ['red', 'maroon', 'wine'],
            'charcoal': ['grey', 'gray', 'dark grey'],
            'ash': ['grey', 'gray', 'silver'],
            'sand': ['beige', 'tan', 'brown', 'khaki'],
            'chocolate': ['brown', 'dark brown'],
            'off white': ['cream', 'ivory', 'white'],
            'mint': ['green', 'light green'],
            // Add 'white' to catch 'white sole' described as just white
            'white': ['white sole'],
            'black': ['black sole']
        };

        const allMedia = Array.from(document.querySelectorAll('.media-wrapper'));

        allMedia.forEach(item => {
            const img = item.querySelector('img');
            const mediaId = parseInt(item.dataset.mediaId);

            let imageBelongsToValue = null;

            // Strategy A: Check Media ID Map (Most Robust)
            if (mediaId && mediaMap[mediaId]) {
                imageBelongsToValue = mediaMap[mediaId];
            }
            // Strategy B: Fallback to Alt Text with Synonyms
            else if (img) {
                const altText = normalize(img.alt || "");

                // Check Exact Matches first
                for (const val of possibleVisualValues) {
                    if (altText.includes(val)) {
                        imageBelongsToValue = val;
                        break;
                    }
                }

                // If no exact match, check Synonyms
                if (!imageBelongsToValue) {
                    for (const val of possibleVisualValues) {
                        const synonyms = synonymMap[val];
                        if (synonyms) {
                            for (const syn of synonyms) {
                                if (altText.includes(syn)) {
                                    imageBelongsToValue = val; // Map back to key (e.g. found 'blue' -> assign to 'navy')
                                    break;
                                }
                            }
                        }
                        if (imageBelongsToValue) break;
                    }
                }
            }

            // Logic: 
            // - If image belongs to NO specific value (Generic), SHOW it.
            // - If image belongs to CURRENT selection, SHOW it.
            // - If image belongs to DIFFERENT selection, HIDE it.

            if (imageBelongsToValue === null || imageBelongsToValue === selectedVisualValue) {
                item.classList.remove('force-hide');
            } else {
                item.classList.add('force-hide');
            }
        });

        // B. Layout Phase
        const primaryContainer = document.querySelector('.ict-media-primary');
        const collageContainer = document.querySelector('.ict-media-collage');
        if (!primaryContainer || !collageContainer) return;

        // Get visible items
        const visibleMedia = allMedia.filter(el => !el.classList.contains('force-hide'));

        if (visibleMedia.length > 0) {
            // 1. Move First to Primary (Hero)
            const hero = visibleMedia[0];
            primaryContainer.appendChild(hero);

            // Ensure Hero Styling
            const heroImg = hero.querySelector('img');
            if (heroImg) {
                heroImg.classList.remove('ict-img-grid');
                heroImg.classList.add('ict-img-main');
            }

            // 2. Move Rest to Collage
            const rest = visibleMedia.slice(1);
            rest.forEach(item => {
                collageContainer.appendChild(item);
                // Ensure Grid Styling
                const gridImg = item.querySelector('img');
                if (gridImg) {
                    gridImg.classList.remove('ict-img-main');
                    gridImg.classList.add('ict-img-grid');
                }
            });
        }
    };


    // 3. Init & Event Listeners
    const initInputs = () => {
        // Iterate over each option index defined in Liquid
        productOptions.forEach((_, idx) => {
            // Try to find div wrappers (not inputs) for this index
            const wrapper = document.querySelector(`div[data-option-index="${idx}"]`);
            
            // Also check for hidden inputs (for "Default Title" options)
            const hiddenInput = document.querySelector(`input[data-option-index="${idx}"]`);
            
            if (wrapper) {
                // First try to find input with checked attribute (from HTML)
                let checkedInput = wrapper.querySelector('input[checked]');
                
                // If not found, try to find any checked input
                if (!checkedInput) {
                    checkedInput = wrapper.querySelector('input:checked');
                }

                // Fallback: If nothing checked, check the first available valid input
                if (!checkedInput) {
                    const firstInput = wrapper.querySelector('input:not([disabled])');
                    if (firstInput) {
                        firstInput.checked = true;
                        checkedInput = firstInput;

                        // If it's a dropdown wrapper, update the button text
                        if (wrapper.classList.contains('ict-size-selector-wrapper')) {
                            const btn = wrapper.querySelector('.ict-size-dropdown-btn span');
                            if (btn) btn.innerText = firstInput.value;
                        }
                    }
                }

                if (checkedInput && checkedInput.value) {
                    state.options[idx] = checkedInput.value;
                    console.log(`✓ Option ${idx} (${productOptions[idx]}) initialized:`, checkedInput.value);

                    // Visual state update
                    if (wrapper.classList.contains('ict-variant-section')) {
                        const parent = checkedInput.closest('.ict-swatch-item');
                        if (parent) parent.classList.add('selected');
                    }
                    if (wrapper.classList.contains('ict-size-selector-wrapper')) {
                        const btn = wrapper.querySelector('.ict-size-dropdown-btn span');
                        if (btn) btn.innerText = checkedInput.value;
                    }
                } else {
                    // Wrapper exists but no inputs found - check for hidden input instead
                    if (hiddenInput && hiddenInput.value) {
                        state.options[idx] = hiddenInput.value;
                        console.log(`✓ Option ${idx} (${productOptions[idx]}) initialized from hidden input (wrapper was empty):`, hiddenInput.value);
                    } else {
                        console.log(`✗ Option ${idx} (${productOptions[idx]}) - No checked input or value found`);
                        console.log(`  Wrapper exists:`, !!wrapper);
                        if (wrapper) {
                            const allInputs = wrapper.querySelectorAll('input[type="radio"]');
                            console.log(`  Total radio inputs found:`, allInputs.length);
                            allInputs.forEach((inp, i) => {
                                console.log(`    Input ${i}: value="${inp.value}", checked=${inp.checked}, hasCheckedAttr=${inp.hasAttribute('checked')}`);
                            });
                        }
                    }
                }
            } else if (hiddenInput) {
                // Hidden input (e.g., "Default Title" option) - set state directly
                if (hiddenInput.value) {
                    state.options[idx] = hiddenInput.value;
                    console.log(`✓ Option ${idx} (${productOptions[idx]}) initialized from hidden input:`, hiddenInput.value);
                }
            }
        });

        console.log("Initial State:", state.options);
        console.log("Product Options:", productOptions);
        console.log("Options with UI count:", document.querySelectorAll('[data-option-index]').length);
        
        // Force update variant after a small delay to ensure DOM is ready
        setTimeout(() => {
            updateVariant();
        }, 100);
        
        filterAndLayout();
    };

    // Generic Event Delegation
    document.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) {
            const wrapper = e.target.closest('[data-option-index]');
            if (wrapper) {
                const idx = parseInt(wrapper.dataset.optionIndex);
                if (!isNaN(idx)) {
                    state.options[idx] = e.target.value;

                    // Visuals
                    if (wrapper.classList.contains('ict-variant-section')) {
                        // Swatch selection logic
                        wrapper.querySelectorAll('.ict-swatch-item').forEach(el => el.classList.remove('selected'));
                        const parent = e.target.closest('.ict-swatch-item');
                        if (parent) parent.classList.add('selected');
                    }

                    updateVariant();

                    // Only refilter images if the changed option was the visual one
                    if (idx === visualOptionIndex) {
                        filterAndLayout();
                    }
                }
            }
        }
    });

    // Dropdown Toggles (Generic)
    document.querySelectorAll('.ict-size-dropdown-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const wrapper = btn.closest('.ict-size-selector-wrapper');
            const content = wrapper.querySelector('.ict-size-dropdown-content');

            // Close others
            document.querySelectorAll('.ict-size-dropdown-content').forEach(c => {
                if (c !== content) c.classList.remove('active');
            });

            if (content) content.classList.toggle('active');
        });
    });

    document.addEventListener('click', () => {
        document.querySelectorAll('.ict-size-dropdown-content').forEach(c => c.classList.remove('active'));
    });

    // Dropdown Option Clicks (Generic)
    document.querySelectorAll('.ict-size-option').forEach(opt => {
        opt.addEventListener('click', function (e) {
            if (this.classList.contains('disabled')) return;

            const radio = this.querySelector('input');
            if (radio) {
                radio.checked = true;
                // Manually trigger logic since programmatic change doesn't fire event
                const wrapper = this.closest('.ict-size-selector-wrapper');
                const btn = wrapper.querySelector('.ict-size-dropdown-btn span');
                if (btn) btn.innerText = this.dataset.value;

                const idx = parseInt(wrapper.dataset.optionIndex);
                if (!isNaN(idx)) {
                    state.options[idx] = this.dataset.value;
                    updateVariant();
                    if (idx === visualOptionIndex) filterAndLayout();
                }

                // Close dropdown
                const content = wrapper.querySelector('.ict-size-dropdown-content');
                if (content) content.classList.remove('active');
            }
        });
    });


    // 4. Modals (Zoom / Size Chart)
    function toggleModal(id, show) {
        const m = document.getElementById(id);
        if (show) m.classList.add('active');
        else m.classList.remove('active');
    }

    document.querySelectorAll('.size-chart-trigger').forEach(btn => btn.addEventListener('click', () => toggleModal('size-chart-modal', true)));
    document.querySelectorAll('.ict-modal-close, .ict-modal-overlay').forEach(el => el.addEventListener('click', function () { this.closest('.ict-modal').classList.remove('active'); }));

    // Zoom Logic (Enhanced)
    const zoomModal = document.getElementById('zoom-modal');
    const zoomTarget = document.getElementById('zoom-target');
    const zoomCanvas = document.querySelector('.ict-zoom-canvas-container');
    const zoomSidebarList = document.getElementById('zoom-thumbs-list');

    let scale = 1;
    let pointX = 0;
    let pointY = 0;
    let isDragging = false;
    let startX = 0;
    let startY = 0;

    const setTransform = () => {
        zoomTarget.style.transform = `translate(${pointX}px, ${pointY}px) scale(${scale})`;
    };

    const resetZoom = () => {
        scale = 1;
        pointX = 0;
        pointY = 0;
        setTransform();
    };

    // Populate Sidebar
    const buildSidebar = () => {
        const visibleMedia = Array.from(document.querySelectorAll('.media-wrapper')).filter(el => !el.classList.contains('force-hide'));
        zoomSidebarList.innerHTML = ''; // Clear

        visibleMedia.forEach(media => {
            const img = media.querySelector('img');
            if (img) {
                const thumb = document.createElement('div');
                thumb.className = 'zoom-thumb-item';
                if (zoomTarget.src === (media.dataset.zoomSrc || img.src)) {
                    thumb.classList.add('active');
                }

                const thumbImg = document.createElement('img');
                thumbImg.src = img.src; // Use smaller image for thumb
                thumb.appendChild(thumbImg);

                thumb.addEventListener('click', () => {
                    // Switch Image
                    zoomTarget.src = media.dataset.zoomSrc || img.src;

                    // Reset Active State
                    document.querySelectorAll('.zoom-thumb-item').forEach(t => t.classList.remove('active'));
                    thumb.classList.add('active');

                    // Reset Zoom
                    resetZoom();
                });

                zoomSidebarList.appendChild(thumb);
            }
        });
    };

    // Pan & Zoom Event Listeners
    if (zoomCanvas) {
        zoomCanvas.addEventListener('mousedown', (e) => {
            isDragging = true;
            startX = e.clientX - pointX;
            startY = e.clientY - pointY;
            zoomCanvas.style.cursor = 'grabbing';
        });

        zoomCanvas.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            e.preventDefault();
            pointX = e.clientX - startX;
            pointY = e.clientY - startY;
            setTransform();
        });

        zoomCanvas.addEventListener('mouseup', () => {
            isDragging = false;
            zoomCanvas.style.cursor = 'grab';
        });

        zoomCanvas.addEventListener('mouseleave', () => {
            isDragging = false;
            zoomCanvas.style.cursor = 'grab';
        });

        zoomCanvas.addEventListener('wheel', (e) => {
            e.preventDefault();
            const xs = (e.clientX - pointX) / scale;
            const ys = (e.clientY - pointY) / scale;
            const delta = -e.deltaY;

            (delta > 0) ? (scale *= 1.2) : (scale /= 1.2);

            // Constraints
            if (scale < 1) scale = 1;
            if (scale > 5) scale = 5;

            // Simple center zoom adjustment or just scale
            // To keep point under mouse stable:
            // pointX = e.clientX - xs * scale;
            // pointY = e.clientY - ys * scale;
            // For simplicity, let's just scale and let user pan

            setTransform();
        });
    }

    // Trigger Open
    document.querySelector('.ict-main-grid').addEventListener('click', function (e) {
        const trigger = e.target.closest('.zoom-trigger');
        if (trigger) {
            const visible = Array.from(document.querySelectorAll('.media-wrapper')).filter(el => !el.classList.contains('force-hide'));
            const idx = visible.indexOf(trigger);
            const img = trigger.querySelector('img');

            if (img && idx !== -1) {
                zoomTarget.src = trigger.dataset.zoomSrc || img.src;
                toggleModal('zoom-modal', true);
                resetZoom();
                buildSidebar();
            }
        }
    });

    // Tabs
    const tabs = document.querySelectorAll('.ict-tab-btn');
    const tabContents = document.querySelectorAll('.ict-tab-content');
    tabs.forEach(tab => {
        tab.addEventListener('click', function () {
            tabs.forEach(t => t.classList.remove('active'));
            tabContents.forEach(c => c.classList.remove('active'));
            this.classList.add('active');
            const targetId = `tab-${this.dataset.tab}`;
            document.getElementById(targetId).classList.add('active');
        });
    });

    // Description "See more" toggle
    const readMoreLink = document.querySelector('.ict-read-more');
    if (readMoreLink) {
        readMoreLink.addEventListener('click', function (e) {
            e.preventDefault();
            const tabContent = this.closest('.ict-tab-content');
            if (tabContent) {
                tabContent.classList.toggle('expanded');
                // Update link text
                if (tabContent.classList.contains('expanded')) {
                    this.textContent = 'See less';
                } else {
                    this.textContent = 'See more';
                }
            }
        });
    }

    // Buy Now button - ensure entire wrapper is clickable
    const buyNowWrapper = document.querySelector('.ict-buy-now-wrapper');
    if (buyNowWrapper) {
        buyNowWrapper.addEventListener('click', function (e) {
            // Find the actual Shopify payment button
            const realButton = this.querySelector('.ict-buy-now-real .shopify-payment-button__button');
            if (realButton) {
                const buttonElement = realButton.querySelector('[role="button"]') || realButton;
                // Only trigger if the click wasn't already on the button itself
                if (e.target !== buttonElement && !buttonElement.contains(e.target)) {
                    buttonElement.click();
                }
            }
        });
    }


    // Handle "Select Options" button click - scroll to variant selectors
    if (addBtn) {
        addBtn.addEventListener('click', function(e) {
            if (this.getAttribute('data-action') === 'select-options') {
                e.preventDefault();
                e.stopPropagation();
                
                // Get options with UI (recalculate to avoid scope issues)
                const optionsWithUI = [];
                productOptions.forEach((_, idx) => {
                    const wrapper = document.querySelector(`[data-option-index="${idx}"]`);
                    if (wrapper) {
                        optionsWithUI.push(idx);
                    }
                });
                
                // Find the first unselected option with UI
                let targetElement = null;
                optionsWithUI.forEach(idx => {
                    if (state.options[idx] === null && !targetElement) {
                        const wrapper = document.querySelector(`[data-option-index="${idx}"]`);
                        if (wrapper) {
                            // Try to find a focusable element
                            const focusable = wrapper.querySelector('input:not([disabled]), select:not([disabled]), button:not([disabled]), .ict-size-dropdown-btn');
                            if (focusable) {
                                targetElement = focusable;
                            } else {
                                targetElement = wrapper;
                            }
                        }
                    }
                });
                
                // If no unselected option found, scroll to first option selector
                if (!targetElement) {
                    const firstWrapper = document.querySelector('[data-option-index]');
                    if (firstWrapper) {
                        const focusable = firstWrapper.querySelector('input:not([disabled]), select:not([disabled]), button:not([disabled]), .ict-size-dropdown-btn');
                        targetElement = focusable || firstWrapper;
                    }
                }
                
                if (targetElement) {
                    // Scroll to element with smooth behavior
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    
                    // Focus the element if it's focusable
                    setTimeout(() => {
                        if (targetElement.focus) {
                            targetElement.focus();
                        }
                        
                        // If it's a dropdown button, open it
                        if (targetElement.classList && targetElement.classList.contains('ict-size-dropdown-btn')) {
                            targetElement.click();
                        }
                    }, 300);
                }
                
                return false;
            }
        });
    }

    // 5. AJAX Add to Cart (No Redirect)
    const productForm = document.querySelector('.ict-actions form');
    if (productForm) {
        productForm.addEventListener('submit', function (e) {
            e.preventDefault();

            const submitBtn = productForm.querySelector('[type="submit"]');
            // Alignment Fix: Target specific span if it exists, otherwise fallback to button
            // Structure is usually: <span>Add to cart</span> <span>$Price</span>
            const textSpan = submitBtn ? submitBtn.querySelector('span:first-child') : null;
            const targetEl = textSpan || submitBtn;

            const originalText = targetEl ? targetEl.innerText : 'Add to cart';

            // Disable button & show spinner/text
            if (submitBtn) {
                submitBtn.disabled = true;
                if (targetEl) targetEl.innerText = 'Adding...';
            }

            const formData = new FormData(productForm);

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.status) {
                        // Error (e.g. Inventory issue)
                        console.error('Error adding to cart:', data.description);
                        if (submitBtn) {
                            if (targetEl) targetEl.innerText = data.description || 'Error';
                            setTimeout(() => {
                                submitBtn.disabled = false;
                                if (targetEl) targetEl.innerText = originalText;
                            }, 2000);
                        }
                    } else {
                        // Success
                        if (submitBtn) {
                            if (targetEl) targetEl.innerText = 'Added!';
                            setTimeout(() => {
                                submitBtn.disabled = false;
                                if (targetEl) targetEl.innerText = originalText;
                            }, 2000);
                        }

                        // Update Cart Counter (Real-time)
                        fetch(window.Shopify.routes.root + '?section_id=cart-icon-bubble')
                            .then(res => res.text())
                            .then(html => {
                                const parser = new DOMParser();
                                const doc = parser.parseFromString(html, 'text/html');
                                const newContent = doc.getElementById('shopify-section-cart-icon-bubble');
                                const cartIcon = document.getElementById('cart-icon-bubble');
                                if (cartIcon && newContent) {
                                    // Preserve the <a> tag structure and classes
                                    // Store original classes and attributes
                                    const originalClasses = cartIcon.className;
                                    const originalHref = cartIcon.href;
                                    const originalId = cartIcon.id;
                                    
                                    // Update innerHTML while preserving the outer structure
                                    cartIcon.innerHTML = newContent.innerHTML;
                                    
                                    // Ensure classes and attributes are preserved
                                    cartIcon.className = originalClasses;
                                    cartIcon.href = originalHref;
                                    cartIcon.id = originalId;
                                    
                                    // Force style recalculation to prevent shrinking
                                    cartIcon.offsetHeight; // Trigger reflow
                                }
                            })
                            .catch(e => console.error('Error updating cart icon:', e));
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    if (submitBtn) {
                        if (targetEl) targetEl.innerText = 'Error';
                        setTimeout(() => {
                            submitBtn.disabled = false;
                            if (targetEl) targetEl.innerText = originalText;
                        }, 2000);
                    }
                });
        });
    }

    // Run Init
    initInputs();

});
